import { CommonApplicationServices } from './services/CommonApplicationServices';

import { Facade, ModuleConfig, ModuleSetup } from '@bolteu/lattice';

import { ProviderPortalTranslationsApiClient } from './api/gen/ProviderPortalTranslationsApiClient';
import config from './config';
import { GlobalRoutes } from './GlobalRoutes';
import { ProviderPortalNavigationService } from './services/ProviderPortalNavigationService';
import { TranslationService } from './services/TranslationService';
import { withPageTracking } from './utils/withPageTracking';

export enum ModuleId {
  Settings = 'settings',
  //... add other module ids here if needed
}

export interface ProviderPortalModuleConfig extends ModuleConfig {
  latticeNavigationService: Facade.GlobalNavigationService;
  navigationService: ProviderPortalNavigationService;
  publisher: Facade.Publisher;
  commonAppServices: CommonApplicationServices;
}

const globalRoutes: string[] = Object.values(GlobalRoutes);

const translationsApiClient = new ProviderPortalTranslationsApiClient(
  config.translationApiClientHost,
);

export abstract class ProviderPortalModuleSetup extends ModuleSetup {
  latticeNavigationService: Facade.NavigationService;
  navigationService: ProviderPortalNavigationService;
  publisher: Facade.Publisher;
  commonAppServices: CommonApplicationServices;
  translationService: TranslationService;

  constructor(public moduleConfig: ProviderPortalModuleConfig) {
    super(moduleConfig);

    this.latticeNavigationService =
      this.moduleConfig.latticeNavigationService.createForModule(this);
    this.navigationService = this.moduleConfig.navigationService.createForModule(this);
    this.commonAppServices = this.moduleConfig.commonAppServices.createForModule(this);
    this.publisher = this.moduleConfig.publisher;

    this.translationService = new TranslationService(this, translationsApiClient);
  }

  getNavigationRestrictions(): Facade.NavigationRestrictions {
    return {
      globalRoutes,
    };
  }

  getRoutes(): Facade.ModuleRoutes {
    return withPageTracking(this.config.moduleName, this.defineRoutes());
  }

  protected abstract defineRoutes(): Facade.ModuleRoutes;

  translationLoaded() {
    this.publisher.publish({
      type: 'module-init',
      payload: {
        module: this,
      },
    });
  }
}
